"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInput = DateInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const lucide_react_1 = require("lucide-react");
const React = __importStar(require("react"));
const button_1 = require("./button");
const calendar_1 = require("./calendar");
const popover_1 = require("./popover");
function DateInput({ value, onChange, className, placeholder, locale, formatString = 'PPP', localeCode, }) {
    const [internalDate, setInternalDate] = React.useState();
    const controlled = typeof value !== 'undefined' || typeof onChange !== 'undefined';
    const date = controlled ? value : internalDate;
    const [open, setOpen] = React.useState(false);
    const setDate = React.useCallback((d) => {
        if (onChange)
            onChange(d);
        if (!controlled)
            setInternalDate(d);
    }, [controlled, onChange]);
    return ((0, jsx_runtime_1.jsxs)(popover_1.Popover, { open: open, onOpenChange: setOpen, children: [(0, jsx_runtime_1.jsx)(popover_1.PopoverTrigger, { asChild: true, children: (0, jsx_runtime_1.jsxs)(button_1.Button, { variant: "outline", "data-empty": !date, className: `data-[empty=true]:text-muted-foreground w-[280px] justify-start text-left font-normal ${className || ''}`, children: [(0, jsx_runtime_1.jsx)(lucide_react_1.Calendar, {}), date ? (localeCode ? (date.toLocaleDateString(localeCode, {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                        })) : ((0, date_fns_1.format)(date, formatString, { locale }))) : ((0, jsx_runtime_1.jsx)("span", { children: placeholder || 'Sélectionner une date' }))] }) }), (0, jsx_runtime_1.jsx)(popover_1.PopoverContent, { className: "w-auto p-0", children: (0, jsx_runtime_1.jsx)(calendar_1.Calendar, { mode: "single", selected: date, onSelect: d => {
                        setDate(d);
                        if (d)
                            setOpen(false);
                    }, locale: locale, localeCode: localeCode }) })] }));
}
